(function () {
	const ORIGINAL_ATTR = "data-ticker-original";
	const MAX_FILL_LOOPS = 20;

	const bindHover = ($section, wrapper) => {
		$section.off("mouseenter.ticker mouseleave.ticker");
		$section.on("mouseenter.ticker", function () {
			wrapper.css("animation-play-state", "paused");
		});
		$section.on("mouseleave.ticker", function () {
			wrapper.css("animation-play-state", "running");
		});
	};

	const observeSection = ($section) => {
		if ($section.data("ticker-observed") || typeof ResizeObserver === "undefined") return;

		$section.data("ticker-observed", true);

		let resizeTimer;
		const observer = new ResizeObserver(() => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				fillAndAnimate($section, false);
			}, 150);
		});

		observer.observe($section[0]);
	};

	const isFilled = (wrapper, containerWidth) => {
		if (!wrapper.data("ticker-prepared")) return false;
		if (wrapper[0].scrollWidth / 2 < containerWidth) return false;

		const originalCount = wrapper.children(`[${ORIGINAL_ATTR}]`).length;
		return wrapper.children().length > originalCount;
	};

	const fillAndAnimate = ($section, force) => {
		const tickerId = $section.data("ticker-id");
		const wrapper = $(`.ticker-js-${tickerId}`);
		if (!wrapper.length) return;

		const speed = Number($section.data("ticker-speed")) * 1000;
		const containerWidth = $section[0].clientWidth;

		if (!force && isFilled(wrapper, containerWidth)) return;

		if (!wrapper.data("ticker-prepared")) {
			wrapper.children().attr(ORIGINAL_ATTR, "");
			wrapper.data("ticker-prepared", true);
		} else {
			wrapper.children().not(`[${ORIGINAL_ATTR}]`).remove();
		}

		const originals = wrapper.children(`[${ORIGINAL_ATTR}]`);
		if (!originals.length) return;

		const originalClone = originals.clone().removeAttr(ORIGINAL_ATTR).attr("aria-hidden", "true");
		let fillLoops = 0;

		while (
			wrapper[0].scrollWidth < containerWidth &&
			wrapper[0].scrollWidth > 0 &&
			fillLoops < MAX_FILL_LOOPS
		) {
			originalClone.clone().appendTo(wrapper);
			fillLoops += 1;
		}

		wrapper.children().clone().removeAttr(ORIGINAL_ATTR).attr("aria-hidden", "true").appendTo(wrapper);

		const fullWidth = wrapper[0].scrollWidth;
		const animationDuration = (fullWidth / 100) * speed / 10000;

		wrapper.css({
			animation: `ticker-scroll ${animationDuration}s linear infinite`,
		});

		bindHover($section, wrapper);
	};

	const ticker = (force) => {
		$(".ticker").each(function () {
			const $section = $(this);
			fillAndAnimate($section, force !== false);
			observeSection($section);
		});
	};

	ticker(true);

	document.addEventListener("shopify:section:load", () => setTimeout(() => ticker(true), 100));

	document.addEventListener("visibilitychange", () => {
		if (!document.hidden) ticker(true);
	});

	if (document.fonts && document.fonts.ready) {
		document.fonts.ready.then(() => ticker(true));
	}

	setTimeout(() => ticker(true), 100);
})();
